import { MapStateToProps, connect } from 'react-redux';
import { FC, memo } from 'react';
import { getAppTitle, getDomainAndPort } from 'api/Utils';
import { RootState } from 'store/store';

import messages from './Messages';
import { Logo, LogoContent } from 'containers/Tasks/TaskSidebar/styles';
import Menu from 'components/Menu';
import Sidebar from 'components/Sidebar';
import { IProvider } from 'store/providers/providerTypes';
import { IUserRoleView } from 'store/companies/companiesTypes';

const appTitle = getAppTitle();

type StateToProps = {
  companyName?: string;
  userRoles?: any;
};

type OwnProps = {
  isCollapsed: boolean;
  isSelfProvider: boolean;
  isAdmin: boolean;
  managingCompanyId: number;
  onCollapse: () => void;
  provider: IProvider;
};

type ComponentProps = OwnProps & StateToProps;
const domainAndPort = getDomainAndPort();

const ContentSidebar: FC<ComponentProps> = ({
  companyName,
  isCollapsed,
  isSelfProvider,
  isAdmin,
  managingCompanyId,
  onCollapse,
  provider,
}) => {
  const hasManagingCompay = managingCompanyId && companyName;
  const RenderManagingCompany = () => {
    return (
      <Menu.Item
        iconType="management.svg"
        key="task"
        label={messages.managingCompanyTasks(companyName!)}
        path={`/t/${managingCompanyId!}/task`}
      />
    );
  };

  return (
    <Sidebar
      collapsed={isCollapsed}
      onCollapse={onCollapse}
      companyId={managingCompanyId}
    >
      <Logo>
        <LogoContent>
          {(provider?.name || appTitle) + 'salama lakdsfjlk dafslkdaf'}
        </LogoContent>
      </Logo>
      {(provider && isSelfProvider) || isAdmin ? (
        <Menu>
          <Menu.Item
            iconType="home.svg"
            exact={true}
            key="create-company"
            label={messages.home}
            path={
              domainAndPort.domainFeatures &&
              domainAndPort.domainFeatures.forceHome
                ? domainAndPort.domainFeatures.forceHome
                : provider.id
                  ? `/content/${provider.id}`
                  : '/homepage'
            }
          />
          <Menu.Divider />
          <Menu.Item
            iconType="setting.svg"
            key="settings"
            label={messages.contentSettings}
            path={`/content/${provider.id}/settings`}
          />
          <Menu.Item
            iconType="tag.svg"
            key="tags"
            label={messages.tags}
            path={`/content/${provider.id}/tags`}
          />
          <Menu.Divider />
          {hasManagingCompay && (
            <>
              {RenderManagingCompany()}
              <Menu.Divider />
            </>
          )}
        </Menu>
      ) : (
        <Menu>
          <Menu.Item
            iconType="home.svg"
            key="create-company"
            label={messages.home}
            path={
              domainAndPort.domainFeatures &&
              domainAndPort.domainFeatures.forceHome
                ? domainAndPort.domainFeatures.forceHome
                : provider.id
                  ? `/content/${provider.id}`
                  : '/home'
            }
          />
          <Menu.Divider />
          {hasManagingCompay && (
            <>
              {RenderManagingCompany()}
              <Menu.Divider />
            </>
          )}
        </Menu>
      )}
    </Sidebar>
  );
};

const mapStateToProps: MapStateToProps<StateToProps, OwnProps, RootState> = (
  state,
  props
) => {
  let userRoles;
  let companyName;
  const companyId = props.managingCompanyId;
  const company = state.companies.data[companyId];
  if (company) {
    companyName = company.name;
    const companyRoles = company.roles;
    if (companyRoles && Object.keys(companyRoles).length > 0) {
      const thisUserId = Number(state.thisUser.userId);
      userRoles = Object.values(companyRoles).filter((role) => {
        return !!role.users.find(
          (user: IUserRoleView) => user.userId === thisUserId
        );
      });
    }
  }
  return {
    companyName,
    userRoles,
  };
};

export default memo(connect(mapStateToProps)(ContentSidebar));
